import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Cheapestcabserviceinmumbai() {



const cardData = {
  keyword: " Cheapest Cab Service in Mumbai",

headingDescription: "Velocity Cab provides the cheapest cab service in Mumbai, offering budget‑friendly and reliable taxi options for local travel, airport transfers, outstation journeys, and corporate trips. We focus on delivering value with transparent pricing, no hidden charges, and quality service that doesn’t compromise comfort. With professional drivers, well‑maintained vehicles, and prompt pickups across Mumbai, you get a safe and affordable ride every time. Choose from air‑conditioned sedans, hatchbacks, and economy vehicles tailored to fit your travel needs. With easy online booking and 24/7 customer support, Velocity Cab is the trusted and economical choice for affordable cab services in Mumbai.",

topPlaces: [

 
 
  {
    title: "Nashik",
    description: "Nashik is a major pilgrimage and wine tourism destination near Mumbai, famous for the Trimbakeshwar Temple and Sula Vineyards. Travelers can enjoy spiritual visits, vineyard tours, and scenic riverfront experiences along the Godavari River."
  },
   {
    title: "Alibaug",
    description: "Alibaug is a beautiful coastal getaway near Mumbai famous for its clean beaches, sea forts, and relaxed vibe. Visitors can enjoy Alibaug Beach, Kolaba Fort, and Mandwa Jetty while experiencing a peaceful seaside escape perfect for weekend trips."
  },
  {
    title: "Igatpuri",
    description: "Igatpuri is a serene hill station located in the Western Ghats, known for its lush greenery, waterfalls, and calm environment. It is ideal for meditation retreats, nature walks, and scenic drives through fog-covered mountains."
  },
   {
    title: "Matheran",
    description: "Matheran is India’s smallest hill station and a unique eco-friendly destination near Mumbai. Known for its vehicle-free environment, visitors can explore viewpoints like Panorama Point and Echo Point while enjoying horse rides and walking trails."
  },
    {
    title: "Lonavala",
    description: "Lonavala is one of the most popular outstation destinations from Mumbai, known for its lush green valleys, misty hills, and scenic waterfalls. Travelers booking a sedan cab can enjoy a comfortable drive via the Mumbai–Pune Expressway and visit attractions like Tiger Point, Bhushi Dam, and Lion’s Point for breathtaking views."
  },
  {
    title: "Shirdi",
    description: "Shirdi is one of India’s most important pilgrimage sites dedicated to Sai Baba. Visitors can visit the Sai Baba Samadhi Mandir, Dwarkamai, and Chavadi while experiencing a peaceful spiritual atmosphere."
  },
  {
    title: "Saputara",
    description: "Saputara is a picturesque hill station in Gujarat near the Maharashtra border, known for its cool climate, lakes, and viewpoints. It offers boating, ropeway rides, and scenic sunset spots ideal for family trips."
  },
  {
    title: "Panchgani",
    description: "Panchgani is a charming hill station near Mumbai famous for its strawberry farms, Table Land plateau, and scenic valley views. It is perfect for relaxing holidays and nature photography."
  },
  {
    title: "Mahabaleshwar",
    description: "Mahabaleshwar is a popular hill station known for its cool weather, strawberry farms, and viewpoints like Arthur’s Seat and Elephant’s Head Point. It is ideal for long weekend getaways from Mumbai."
  },
  {
    title: "Kashid Beach",
    description: "Kashid Beach is a peaceful coastal destination near Mumbai known for its white sand, clear waters, and water sports activities. It is a great spot for relaxation, camping, and seaside drives."
  }
],



services: [
{
name: "Cheap Cab Service Mumbai",
description: "Cheap cab service Mumbai provides affordable and reliable transportation for daily travel, airport transfers, and outstation trips without compromising on comfort and safety. This service is ideal for budget-conscious travelers who want dependable cab options at economical rates. Customers can choose from a range of vehicles including sedan and hatchback options based on their travel needs. Professional drivers ensure safe and smooth journeys across Mumbai and nearby destinations. Transparent pricing with no hidden charges makes it easy to plan travel expenses. Flexible booking options and 24x7 availability add convenience. It is the perfect solution for cost-effective and comfortable travel in Mumbai."
},
{
name: "Lowest Price Cab Mumbai",
description: "Lowest price cab Mumbai offers highly competitive fares for customers looking for economical travel options within the city and for outstation journeys. This service focuses on providing value for money while maintaining service quality and safety standards. Vehicles are well-maintained and driven by experienced drivers to ensure a comfortable ride. Ideal for daily commuters, students, and frequent travelers. Transparent pricing ensures no extra or hidden costs. Easy booking options make it convenient for customers. It is one of the best choices for low-cost travel."
},
{
name: "Budget Taxi Service Mumbai",
description: "Budget taxi service Mumbai is designed for travelers who want affordable yet reliable transportation for city rides and long-distance travel. This service provides economical fare options while ensuring comfort and safety. Customers can select from different vehicle categories based on their needs. Professional drivers ensure timely pickups and smooth journeys. Flexible booking options allow easy travel planning. It is suitable for both personal and business travel. It offers a balance between cost and convenience."
},
{
name: "Affordable Cab Service Mumbai",
description: "Affordable cab service Mumbai provides cost-effective travel solutions for individuals, families, and corporate travelers. This service ensures comfortable rides at reasonable prices with well-maintained vehicles and trained drivers. Ideal for daily travel, airport transfers, and outstation trips. Transparent billing ensures no hidden charges for customers. Flexible pickup and drop options enhance convenience. It is widely preferred for budget-friendly travel. It ensures reliable and comfortable journeys."
},
{
name: "Cheap Outstation Cab Mumbai",
description: "Cheap outstation cab Mumbai offers economical travel options for long-distance trips to destinations like Pune, Nashik, Lonavala, and Shirdi. This service is ideal for travelers looking for affordable intercity transportation. Vehicles are maintained for highway travel ensuring safety and comfort. Flexible packages include one way and round trip options. Professional drivers ensure smooth and timely journeys. Transparent pricing makes budgeting easy. It is a great choice for affordable outstation travel."
},
{
name: "Cheap Airport Cab Mumbai",
description: "Cheap airport cab Mumbai provides budget-friendly airport pickup and drop services with timely and reliable transportation. This service is ideal for travelers looking for economical airport transfers without compromising on comfort. Drivers track flight timings to ensure punctual service. Clean and well-maintained vehicles enhance the travel experience. Flexible booking options are available for convenience. It ensures a smooth and stress-free airport journey. It is perfect for affordable airport travel."
},
{
name: "Low Fare Taxi Mumbai",
description: "Low fare taxi Mumbai offers economical travel options for daily commuting and long-distance journeys. This service is designed for customers who want reliable transportation at minimal cost. Vehicles are clean, comfortable, and maintained for safe travel. Professional drivers ensure timely service across all routes. Flexible booking options make travel planning easy. It is ideal for budget-conscious travelers. It ensures cost-effective and convenient transportation."
},
{
name: "Discount Cab Booking Mumbai",
description: "Discount cab booking Mumbai provides special offers and reduced fares for customers looking to save on travel expenses. This service is ideal for frequent travelers and those planning trips in advance. Customers can take advantage of seasonal discounts and promotional offers. Transparent pricing ensures clarity in billing. Professional drivers ensure safe and comfortable journeys. Easy booking options make it convenient for all users. It is a great way to enjoy affordable travel with added savings."
},
{
name: "Economy Cab Service Mumbai",
description: "Economy cab service Mumbai offers practical and budget-friendly transportation for city and outstation travel. This service is ideal for travelers who prioritize affordability while maintaining basic comfort standards. Vehicles are well-maintained and suitable for daily travel needs. Professional drivers ensure safe and efficient journeys. Flexible booking options make it easy to plan trips. It is widely preferred for economical travel solutions. It ensures reliable service at low cost."
},
{
name: "Cheap One Way Cab Mumbai",
description: "Cheap one way cab Mumbai provides cost-effective travel solutions for single-side journeys without return charges. This service is ideal for airport drops, intercity travel, and business trips. Customers benefit from reduced pricing compared to round trips. Multiple vehicle options are available based on comfort and budget. Professional drivers ensure safe and timely service. Easy booking with instant confirmation adds convenience. It is a smart choice for affordable one way travel."
}
],

tableData: [
["Cheap Cab Service Mumbai","Lowest Price Cab Mumbai"],
["Budget Taxi Service Mumbai","Affordable Cab Service Mumbai"],
["Cheap Outstation Cab Mumbai","Cheap Airport Cab Mumbai"],
["Low Fare Taxi Mumbai","Discount Cab Booking Mumbai"],
["Economy Cab Service Mumbai","Cheap One Way Cab Mumbai"]
],


whychoose: [
  {
    WhyChooseheading: "Affordable & Budget-Friendly Pricing",
    WhyChoosedescription: "Velocity Cabs offers cheapest cab service in Mumbai with highly competitive pricing starting from economical per km rates, making it ideal for daily travel, airport rides, and outstation trips."
  },
  {
    WhyChooseheading: "Transparent Fare Structure",
    WhyChoosedescription: "We provide complete fare transparency with clear pricing details including per km charges, tolls, and driver allowance, so customers never face hidden costs."
  },
  {
    WhyChooseheading: "Best Price in Mumbai Market",
    WhyChoosedescription: "Compared to standard taxi fares in Mumbai that typically start around ₹10–₹14 per km for local travel, Velocity Cabs ensures even more affordable deals for regular and long-distance customers." 
  },
  {
    WhyChooseheading: "24/7 Cab Availability",
    WhyChoosedescription: "Our cheapest cab service in Mumbai operates 24/7, allowing customers to book rides anytime for local travel, airport transfer, or outstation journeys."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "All vehicles are fully air-conditioned, well maintained, and regularly cleaned to provide a comfortable travel experience even at budget-friendly prices."
  },
  {
    WhyChooseheading: "Multiple Budget Vehicle Options",
    WhyChoosedescription: "Velocity Cabs offers hatchbacks, sedan cars, and SUVs like Ertiga and Innova, allowing customers to choose affordable options based on their travel needs."
  },
  {
    WhyChooseheading: "Doorstep Pickup Across Mumbai",
    WhyChoosedescription: "We provide convenient pickup from homes, offices, hotels, railway stations, and airports across Mumbai for easy and hassle-free travel."
  },
  {
    WhyChooseheading: "Trusted Low Cost Cab Service",
    WhyChoosedescription: "Velocity Cabs is trusted by many customers for cheapest cab service in Mumbai due to reliable drivers, comfortable rides, and consistent service quality."
  }
]
};

const faqData = [
  { question: "Do you provide cheapest cab service in Mumbai?", answer: "Yes, Velocity Cabs provides budget-friendly cab services in Mumbai for local, airport, and outstation travel." },
  { question: "What is the starting fare of cabs in Mumbai?", answer: "Cab fares in Mumbai generally start from around ₹9 to ₹14 per km depending on vehicle type and service provider." },
  { question: "Which is the cheapest cab type?", answer: "Hatchback and sedan cars are the most economical options for budget travel in Mumbai." },
  { question: "Is cheap cab service available 24 hours?", answer: "Yes, our cab service operates 24/7 for customer convenience." },
  { question: "Can I book cheap cab for airport transfer?", answer: "Yes, we provide affordable airport pickup and drop services in Mumbai." },
  { question: "Are low-cost cabs safe?", answer: "Yes, all our drivers are verified and vehicles are well maintained to ensure safe travel." },
  { question: "Can I book cab online at low price?", answer: "Yes, customers can easily book cheapest cab service in Mumbai online or through phone booking." },
  { question: "Do you provide one-way cheap cabs?", answer: "Yes, we offer both one-way and round-trip affordable cab options." },
  { question: "Is advance booking required?", answer: "Advance booking is recommended to get the best price and availability." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly to ensure passenger safety and hygiene." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Sandeep Joshi",
    feedback:
      "I found Velocity Cabs to be one of the most budget-friendly options for travel in Mumbai. The pricing was fair, the cab was clean, and the overall ride experience was smooth.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Kavita Iyer",
    feedback:
      "Velocity Cabs offers very affordable cab services in Mumbai without compromising on comfort. The driver was polite, and the journey was completed safely at a reasonable cost.",
    rating: 5
  }
];






















const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
{ place: "/images/keyword/2.jpg", text: "Pune to Mumbai Airport Cabs", link: "Pune-to-Mumbai-Airport-Cabs" },
{ place: "/images/keyword/3.jpg", text: "Pune to Mumbai International Airport Cabs", link: "Pune-to-Mumbai-International-Airport-Cabs" },
{ place: "/images/keyword/4.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
{ place: "/images/keyword/5.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
{ place: "/images/keyword/6.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
{ place: "/images/keyword/7.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
{ place: "/images/keyword/8.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
{ place: "/images/keyword/9.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
{ place: "/images/keyword/10.jpg", text: "Hinjewadi to Mumbai Cabs", link: "Hinjewadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/11.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/12.jpg", text: "Wakad to Mumbai Cabs", link: "Wakad-to-Mumbai-Cabs" },
{ place: "/images/keyword/13.jpg", text: "Hadapsar to Mumbai Cabs", link: "Hadapsar-to-Mumbai-Cabs" },
{ place: "/images/keyword/14.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
{ place: "/images/keyword/15.jpg", text: "Koregaon Park to Mumbai Cabs", link: "Koregaon-Park-to-Mumbai-Cabs" },
{ place: "/images/keyword/16.jpg", text: "Kothrud to Mumbai Cabs", link: "Kothrud-to-Mumbai-Cabs" },
{ place: "/images/keyword/17.jpg", text: "Kharadi to Mumbai Cabs", link: "Kharadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/18.jpg", text: "Shivajinagar to Mumbai Cabs", link: "Shivajinagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/19.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
{ place: "/images/keyword/20.jpg", text: "Pune to Mumbai Innova Crysta Cabs", link: "Pune-to-Mumbai-Innova-Crysta-Cabs" },
{ place: "/images/keyword/21.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
{ place: "/images/keyword/22.jpg", text: "Kondhwa to Mumbai Cabs", link: "Kondhwa-to-Mumbai-Cabs" },
{ place: "/images/keyword/23.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/24.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/25.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
];













const cheapestCabMumbaiJSON = {
  "@context": "https://schema.org",
  "@type": "TouristTrip",
  "name": "Cheapest Cab Service in Mumbai | Velocity Cabs",
  "description": "Book the cheapest cab service in Mumbai for city trips, airport transfers, or outstation travel. AC, Sedan, and SUV taxis available at affordable fares for one-way or round trips.",
  "provider": {
    "@type": "Organization",
    "name": "Velocity Cabs",
    "url": "https://www.velocitycabs.com/"
  },
  "areaServed": {
    "@type": "Place",
    "name": "Mumbai, Maharashtra, India"
  },
  "hasOfferCatalog": {
    "@type": "OfferCatalog",
    "name": "Cheapest Cab Packages in Mumbai",
    "itemListElement": [
      {
        "@type": "Offer",
        "name": "Cheap One Way Cab in Mumbai",
        "description": "Affordable one-way cab service in Mumbai with AC, SUV, or Sedan options.",
        "url": "https://www.velocitycabs.com/",
        "priceCurrency": "INR",
        "availability": "https://schema.org/InStock"
      },
      {
        "@type": "Offer",
        "name": "Round Trip Cheap Cab in Mumbai",
        "description": "Budget-friendly round-trip cab service in Mumbai with private AC/SUV/Sedan options.",
        "url": "https://www.velocitycabs.com/",
        "priceCurrency": "INR",
        "availability": "https://schema.org/InStock"
      }
    ]
  }
};





  return (
    <div>
      
<Helmet>
  <title>Cheapest Cab Service in Mumbai | Velocity Cabs +91 9136271336</title>
  <meta
    name="description"
    content="Book the cheapest cab service in Mumbai for city trips, airport transfers, or outstation travel. AC, Sedan, and SUV taxis available at affordable fares for one-way or round trips."
  />
  <script type="application/ld+json">
    {JSON.stringify(cheapestCabMumbaiJSON)}
  </script>
</Helmet>

 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/102.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Velocity Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚗
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Velocity Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Velocity Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


               <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919136271336" className="pc-call">+91 9136271336</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919136271336"
          target="_blank"
          rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp"></i> WhatsApp
        </a>
        <a href="tel:+919136271336" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@velocitycabs.com" className="pc-email">
        booking@velocitycabs.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-geo-alt-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Velocity Cab</strong><br />
        Prakash Residency, Sec 10E, Plot 40 Roadpali, Kalamboli 410218 Navi Mumbai, Maharashtra
      </address>
    </section>
  </div>
</div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Cheapestcabserviceinmumbai;